import { ArrowRight, TrendingUp } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CASE_STUDIES, CLIENT_WORDMARKS } from "@/data/content";

export function CaseStudies() {
  return (
    <section className="border-t border-white/10 py-20 lg:py-28" data-testid="case-studies">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand">Client results</p>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase tracking-tight text-white sm:text-5xl lg:text-6xl">
            Proof, not <span className="text-brand">promises.</span>
          </h2>
          <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-dim">
            Sample engagements shown — client names anonymized
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div
            className="mt-10 flex flex-wrap items-center gap-x-10 gap-y-4 border-y border-white/10 py-6"
            data-testid="client-logo-wall"
          >
            {CLIENT_WORDMARKS.map((w) => (
              <span
                key={w}
                className="font-display text-lg font-black uppercase tracking-[0.15em] text-white/25 transition-colors duration-300 hover:text-white/70 sm:text-xl"
              >
                {w}
              </span>
            ))}
          </div>
        </Reveal>

        <div className="mt-10 grid gap-6 md:grid-cols-2">
          {CASE_STUDIES.map((c, i) => (
            <Reveal key={c.client} delay={i * 0.06}>
              <div
                data-testid={`case-study-${c.client.toLowerCase()}`}
                className="glow-card h-full rounded-2xl border border-white/10 bg-surface p-6 sm:p-8"
              >
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <h3 className="font-display text-2xl font-bold text-white">{c.client}</h3>
                    <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.2em] text-dim">
                      {c.industry}
                    </p>
                  </div>
                  <TrendingUp className="h-6 w-6 shrink-0 text-brand" strokeWidth={1.5} />
                </div>

                <div className="mt-8 flex flex-wrap items-end gap-x-5 gap-y-3">
                  <div>
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-dim">Before</p>
                    <p className="font-display text-2xl font-bold text-white/35">{c.before}</p>
                  </div>
                  <ArrowRight className="mb-1.5 h-5 w-5 text-brand" />
                  <div>
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-dim">After</p>
                    <p className="font-display text-4xl font-black text-volt">{c.after}</p>
                  </div>
                  <p className="mb-1 ml-auto text-right font-mono text-[11px] leading-tight text-muted2">
                    {c.metric}
                    <br />
                    {c.period}
                  </p>
                </div>

                <p className="mt-6 text-sm leading-relaxed text-muted2">{c.summary}</p>
                <div className="mt-5 flex flex-wrap gap-2">
                  {c.services.map((s) => (
                    <span
                      key={s}
                      className="rounded-full border border-white/10 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.15em] text-dim"
                    >
                      {s}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
